import React, { memo, useContext } from 'react'
import { ClockMinor } from '@shopify/polaris-icons'
import { ContractorsTableContext } from '../contractors-table/ContractorsTable.context'
import { TableSelect } from 'src/components/shared/table/TableSelect'
import { ExpirationIndicator } from 'src/interfaces/contractor'
import { ExpirationIndicatorChip } from './ExpirationIndicatorChip'

const expirationOptions = [
  {
    value: ExpirationIndicator.Valid,
    component: (
      <ExpirationIndicatorChip
        expirationIndicator={ExpirationIndicator.Valid}
        label="More than 30 days"
      />
    ),
  },
  {
    value: ExpirationIndicator.ExpiringSoon,
    component: (
      <ExpirationIndicatorChip
        expirationIndicator={ExpirationIndicator.ExpiringSoon}
        label="30 days and less"
      />
    ),
  },
  {
    value: ExpirationIndicator.Expired,
    component: (
      <ExpirationIndicatorChip expirationIndicator={ExpirationIndicator.Expired} label="Expired" />
    ),
  },
]

const ContractorExpirationSelectComponent = () => {
  const { expirationIndicatorFilter, setExpirationIndicatorFilter } =
    useContext(ContractorsTableContext)

  return (
    <TableSelect<ExpirationIndicator>
      title="Expires"
      icon={<ClockMinor width={20} />}
      options={expirationOptions}
      selectedValues={expirationIndicatorFilter}
      onSelect={setExpirationIndicatorFilter}
      triggerDataTestId="contractors-list-main-expiration-menu-btn"
      clearAllDataTestId="contractors-list-main-expiration-clear-all"
    />
  )
}

export const ContractorExpirationSelect = memo(ContractorExpirationSelectComponent)
